import { render } from "./CartSummary.vue?vue&type=template&id=9989c560&scoped=true"
import script from "./CartSummary.vue?vue&type=script&lang=js"
export * from "./CartSummary.vue?vue&type=script&lang=js"

import "./CartSummary.vue?vue&type=style&index=0&id=9989c560&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9989c560"]])

export default __exports__